// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__jKwQh","load6":"Spinner_load6__RwfVT","round":"Spinner_round__EBidt"};